<app-header></app-header>
<ion-content scroll-y="false">
  <ng-container *ngIf="{value: progressBarValue$ | async} as progressBar">
    <div
      id="desktop"
      *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
    >
      <cdk-virtual-scroll-viewport
        class="cdk-scroll-desktop-my-orders"
        orientation="vertical"
        itemSize="87"
        minBufferPx="2000"
        maxBufferPx="4000"
      >
        <div class="top-section-background">
          <ion-grid [fixed]="true">
            <div class="header-section-top">
              <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
              <ion-button
                [disabled]="progressBar.value < 1 || myOrders?.orderCounts?.totalCount === 0"
                class="btn-download"
                data-cy="download-order-button"
                fill="clear"
                (click)="showDownloadImportedOrdersModal(true)"
              >
                <ion-icon name="download-outline"></ion-icon>
                {{ 'i18n.orderPage.download' | translate }}
              </ion-button>
            </div>
            <div class="top-section-header">
              <div class="header-section">
                <h1 data-cy="usf-filtering-banner-title-text">
                  {{ 'i18n.importOrderPage.importedOrders' | translate |
                  uppercase }}
                </h1>
              </div>
              <app-usf-filtering-banner-desktop
                [isLoading]="false"
                [quickFilters]="myOrders?.quickFilters"
                [numberOfSelectedFilters]="0"
                [showQuickDateFilterOption]="true"
                [showResetFilterOption]="false"
                [showViewTodaysOrdersButton]="true"
                [showFilterModalButton]="false"
                (quickFiltersClicked)="toggleStatusFilter($event)"
                [filterDateRange]="importedDateRange"
                (changeDateFilterClicked)="openCalendarModal()"
                (viewTodaysOrdersClicked)="getTodaysOrders()"
              ></app-usf-filtering-banner-desktop>
            </div>
          </ion-grid>
        </div>
        <div class="bottom-section-background">
          <ion-grid [fixed]="true">
            <div
              data-cy="submission-progress-bar"
              class="submission-progress-bar"
              [hidden]="progressBar.value  >= 1"
            >
              <div
                data-cy="submission-progress-bar-text"
                class="progress-bar-message"
              >
                {{'i18n.importOrderPage.submissionProcessing' | translate}}
              </div>
              <ion-progress-bar
                data-cy="submission-progress-bar-loader"
                [value]="progressBar.value"
              ></ion-progress-bar>
            </div>

            <div
              *ngIf="!!myOrders?.myOrdersRows && myOrders?.myOrdersRows.length === 0"
              data-cy="no-orders-container"
              class="no-orders-container"
            >
              <img
                src="assets/images/box-dimension-black.svg"
                class="box-dimension-image"
                alt="box-image"
              />
              <p data-cy="no-open-orders-message">
                {{'i18n.importOrderPage.noImportedOrders' | translate}}
              </p>
              <ion-button
                class="usf-fill-green-button"
                (click)="openImportOrderModal(true)"
                data-cy="create-new-order-button"
                >{{'i18n.importOrderModal.importOrder' | translate}}</ion-button
              >
            </div>

            <app-imported-orders-list-desktop
              [ordersList]="myOrders"
            ></app-imported-orders-list-desktop>
          </ion-grid>
        </div>
        <div class="footer-wrapper">
          <app-footer></app-footer>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>

    <!-- TOUCH EXPERIENCE -->
    <ng-container
      *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
    >
      <!-- TABLET -->
      <div class="container">
        <div class="bottom-section-background-touch">
          <cdk-virtual-scroll-viewport
            class="cdk-scroll-touch"
            orientation="vertical"
            appCustomVs
            [itemHeights]="myOrders?.itemHeights"
            [indexOffset]="0"
            [bufferBefore]="50"
            [bufferAfter]="50"
          >
            <div></div>
            <div class="header-section tablet">
              <ion-button
                [disabled]="progressBar.value < 1 || myOrders?.orderCounts?.totalCount === 0"
                class="btn-download"
                data-cy="download-order-button"
                fill="clear"
                (click)="showDownloadImportedOrdersModal(true)"
              >
                <ion-icon name="download-outline"></ion-icon>
                {{ 'i18n.orderPage.download' | translate }}
              </ion-button>
              <app-usf-filtering-banner-tablet
                [isLoading]="false"
                [quickFilters]="myOrders?.quickFilters"
                [numberOfSelectedFilters]="numberOfSelectedFilters"
                [showQuickDateFilterOption]="true"
                [showViewTodaysOrdersButton]="true"
                [showResetFilterOption]="false"
                [showFilterModalButton]="false"
                (quickFiltersClicked)="toggleStatusFilter($event)"
                [filterDateRange]="importedDateRange"
                (changeDateFilterClicked)="openCalendarModal()"
                (viewTodaysOrdersClicked)="getTodaysOrders()"
              ></app-usf-filtering-banner-tablet>

              <div
                data-cy="submission-progress-bar-tablet"
                class="submission-progress-bar-tablet"
                [hidden]="progressBar.value >= 1"
              >
                <div
                  data-cy="submission-progress-bar-text"
                  class="progress-bar-message"
                >
                  {{'i18n.importOrderPage.submissionProcessing' | translate}}
                </div>
                <ion-progress-bar
                  data-cy="submission-progress-bar-loader"
                  [value]="progressBar.value"
                ></ion-progress-bar>
              </div>
            </div>
            <div
              *ngIf="!!myOrders?.myOrdersRows && myOrders?.myOrdersRows.length === 0"
              class="no-orders-container"
              data-cy="no-orders-container"
            >
              <img
                src="assets/images/box-dimension-black.svg"
                class="box-dimension-image"
                alt="box-image"
              />
              <p data-cy="no-open-orders-message">
                {{'i18n.importOrderPage.noImportedOrders' | translate}}
              </p>
              <ion-button
                class="usf-fill-green-button"
                (click)="openImportOrderModal(true)"
                data-cy="create-new-order-button"
                >{{'i18n.importOrderModal.importOrder' | translate}}</ion-button
              >
            </div>

            <app-imported-orders-list-tablet
              [ordersList]="myOrders"
            ></app-imported-orders-list-tablet>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
    </ng-container>

    <ng-container
      *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
    >
      <!-- MOBILE -->
      <div class="container">
        <div class="bottom-section-background-touch">
          <cdk-virtual-scroll-viewport
            class="cdk-scroll-touch"
            orientation="vertical"
            appCustomVs
            [itemHeights]="myOrders?.itemHeights"
            [indexOffset]="0"
            [bufferBefore]="10"
            [bufferAfter]="10"
          >
            <ion-icon
              class="additional-info-ellipsis"
              [class.disabled]="progressBar.value < 1"
              data-cy="additional-info-ellipsis-icon"
              name="ellipsis-vertical-circle-sharp"
              (click)="showImportedOrdersActionSheet(true)"
            ></ion-icon>
            <app-usf-filtering-banner-mobile
              [isLoading]="false"
              [quickFilters]="myOrders?.quickFilters"
              [numberOfSelectedFilters]="numberOfSelectedFilters"
              [showQuickDateFilterOption]="true"
              [showResetFilterOption]="false"
              [showViewTodaysOrdersButton]="true"
              [showFilterModalButton]="false"
              (quickFiltersClicked)="toggleStatusFilter($event)"
              [filterDateRange]="importedDateRange"
              (changeDateFilterClicked)="openCalendarModal()"
              (viewTodaysOrdersClicked)="getTodaysOrders()"
            ></app-usf-filtering-banner-mobile>
            <div
              data-cy="submission-progress-bar-mobile"
              class="submission-progress-bar-mobile"
              [hidden]="progressBar.value >= 1"
            >
              <div
                data-cy="submission-progress-bar-text"
                class="progress-bar-message"
              >
                {{'i18n.importOrderPage.submissionProcessing' | translate}}
              </div>
              <ion-progress-bar
                data-cy="submission-progress-bar-loader"
                [value]="progressBar.value"
              ></ion-progress-bar>
            </div>
            <div
              *ngIf="!!myOrders?.myOrdersRows && myOrders?.myOrdersRows.length === 0"
              class="no-orders-container"
              data-cy="no-orders-container"
            >
              <img
                src="assets/images/box-dimension-black.svg"
                class="box-dimension-image"
                alt="box-image"
              />
              <p data-cy="no-open-orders-message">
                {{'i18n.importOrderPage.noImportedOrders' | translate}}
              </p>
              <ion-button
                class="usf-fill-green-button"
                (click)="openImportOrderModal(true)"
                data-cy="create-new-order-button"
                >{{'i18n.importOrderModal.importOrder' | translate}}</ion-button
              >
            </div>
            <app-imported-orders-list-mobile
              [ordersList]="myOrders"
            ></app-imported-orders-list-mobile>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
      <ng-container
        *ngIf="myOrders?.orderCounts?.totalCount > 0; else noDownloadOption"
      >
        <ion-action-sheet
          class="action-sheet-touch"
          mode="ios"
          [isOpen]="importedOrdersActionSheetIsOpen$ | async"
          (didDismiss)="showImportedOrdersActionSheet(false)"
          [buttons]="actionSheetButtons"
        ></ion-action-sheet>
      </ng-container>
      <ng-template #noDownloadOption>
        <ion-action-sheet
          class="action-sheet-touch"
          mode="ios"
          [isOpen]="importedOrdersActionSheetIsOpen$ | async"
          (didDismiss)="showImportedOrdersActionSheet(false)"
          [buttons]="actionSheetButtonsWithoutDownload"
        ></ion-action-sheet>
      </ng-template>
    </ng-container>
  </ng-container>
</ion-content>

<div data-cy="order-status-top-button-section" class="top-button">
  <ion-button
    data-cy="order-status-top-button"
    class="usf-fill-green-button"
    (click)="goToTop()"
  >
    {{ 'i18n.common.top' | translate }}&nbsp;
    <ion-icon
      data-cy="order-status-top-button-icon"
      name="chevron-up-circle-outline"
    ></ion-icon>
  </ion-button>
</div>

<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-lg'"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="downloadImportedOrdersModalIsOpen$ | async"
  (ionModalDidDismiss)="showDownloadImportedOrdersModal(false)"
>
  <ng-template>
    <app-download-order-modal
      class="ion-page"
      [orders]="importedOrders$ | async"
      [fileTypes]="downloadImportedOrdersFileTypes"
      [platform]="platformService.platformType"
      (dismissEvent)="showDownloadImportedOrdersModal(false)"
      (downloadOrdersEmitter)="handleDownloadImportedOrders($event)"
      fileName="Imported_Orders_{{myOrders?.filters?.filters?.importedDate | date: 'MMddyyyy'}}"
    >
    </app-download-order-modal>
  </ng-template>
</ion-modal>

<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-xl'"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="importOrderModalIsOpen$ | async"
  (ionModalDidDismiss)="handleImportModalDismiss($event)"
>
  <ng-template>
    <ng-container
      *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
    >
      <app-import-order-modal-mobile
        (isOpenEmitter)="openImportOrderModal($event)"
        (importOrderEmitter)="importOrderHandler($event)"
        (importSuccessEmitter)="handleImportSuccess($event)"
        (initializeImportOrderStateEmitter)="initializeImportOrderState($event)"
        [fileImportErrors$]="fileImportErrors$"
        [loading$]="importOrdersLoading$"
        [loaded$]="importOrdersLoaded$"
        [orderTransactions$]="importOrdersTransactions$"
        [fileImportMessage$]="fileImportMessage$"
        [apiError$]="apiError$"
        class="ion-page"
      ></app-import-order-modal-mobile>
    </ng-container>
    <ng-container
      *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
    >
      <app-import-order-modal
        (isOpenEmitter)="openImportOrderModal($event)"
        (importOrderEmitter)="importOrderHandler($event)"
        (importSuccessEmitter)="handleImportSuccess($event)"
        (initializeImportOrderStateEmitter)="initializeImportOrderState($event)"
        [fileImportErrors$]="fileImportErrors$"
        [loading$]="importOrdersLoading$"
        [loaded$]="importOrdersLoaded$"
        [orderTransactions$]="importOrdersTransactions$"
        [fileImportMessage$]="fileImportMessage$"
        [apiError$]="apiError$"
        class="ion-page"
      ></app-import-order-modal>
    </ng-container>
  </ng-template>
</ion-modal>
